import { api } from './api';

export interface SavedPrompt {
  id: string;
  agentKind: string;
  title: string;
  body: string;
  createdBy: string | null;
  createdAt: string;
}

export const promptsApi = {
  async list(wsId: string, agentKind?: string): Promise<SavedPrompt[]> {
    const r = await api.get<SavedPrompt[]>(`/api/workspaces/${wsId}/prompts`, {
      params: agentKind ? { agentKind } : undefined,
    });
    return r.data;
  },
  async create(wsId: string, body: { title: string; body: string; agentKind?: string }): Promise<SavedPrompt> {
    const r = await api.post<SavedPrompt>(`/api/workspaces/${wsId}/prompts`, body);
    return r.data;
  },
  async remove(wsId: string, id: string): Promise<void> {
    await api.delete(`/api/workspaces/${wsId}/prompts/${id}`);
  },
};
